var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatherIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30.77px",
    height: "30.771px",
    viewBox: "0 0 30.77 30.771",
    style: {
      enableBackground: "new 0 0 30.77 30.771"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.846,26.83l3.018-3.019c4.628,1.044,8.737,0.533,12.21-1.561c6.342-3.821,8.213-11.45,8.289-11.772 c0.127-0.535-0.099-1.094-0.565-1.385c-0.235-0.148-0.505-0.211-0.771-0.193c2.053-3.518,2.305-7.027,2.316-7.224 c0.042-0.659-0.422-1.24-1.071-1.349c-7.062-1.172-12.752,0.798-16.95,5.858c-0.119-0.183-0.288-0.333-0.488-0.436 c-0.439-0.223-0.967-0.176-1.359,0.123c-5.959,4.532-5.052,12.153-3.532,16.226l-2.913,2.914c-0.501,0.501-0.502,1.313,0,1.815 C3.531,27.332,4.344,27.332,4.846,26.83z M9.186,9.766c0.008,0.027,0.016,0.056,0.025,0.083c0.182,0.563,0.798,0.974,1.386,0.914 c0.674-0.068,0.974-0.526,1.392-1.16c1.319-2.004,5.22-7.933,14.619-6.911c-0.347,1.809-1.352,5.318-4.146,7.821 c-0.424,0.379-0.549,0.992-0.305,1.505c0.242,0.516,0.795,0.809,1.356,0.721c0.209-0.031,0.769-0.125,1.442-0.294 c-1,2.307-2.922,5.633-6.224,7.616c-2.891,1.734-6.365,2.156-10.334,1.254C7.733,19.523,6.068,13.949,9.186,9.766z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.598,27.771H2.172c-0.829,0-1.5,0.672-1.5,1.5s0.671,1.5,1.5,1.5h26.426c0.829,0,1.5-0.672,1.5-1.5 S29.427,27.771,28.598,27.771z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherIcon);
export default __webpack_public_path__ + "static/media/featherIcon.dd28ecd6871dc0077e9369a5e5507088.svg";
export { ForwardRef as ReactComponent };